import { render, staticRenderFns } from "./CardLatestView.vue?vue&type=template&id=4e334d9b&"
import script from "./CardLatestView.vue?vue&type=script&lang=ts&"
export * from "./CardLatestView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports